module.exports = __webpack_public_path__ + "img/bicycleRearRightOutline.0a2b9880.svg";